import { z } from 'zod';
import {
  markIdFilterDefaultValue,
  markIdFilterSchema,
  markerFilterDefaultValue,
  markerFilterSchema,
  nsnFilterDefaultValue,
  nsnFilterSchema,
  responseIdFilterDefaultValue,
  responseIdFilterSchema
} from 'pages/marking/schemas/shared-filter-form.schema';

export const reviewerFilterSchema = z.object({
  reviewerOrganisationUserIds: z.array(z.number()) // The organisation user ID of the reviewer.
});
export const reviewerFilterDefaultValue = { reviewerOrganisationUserIds: [] };

export const filterFormSchema = z.intersection(
  z.intersection(
    z.intersection(nsnFilterSchema, responseIdFilterSchema),
    z.intersection(markIdFilterSchema, markerFilterSchema)
  ),
  reviewerFilterSchema
);

export type FilterFormValues = z.infer<typeof filterFormSchema>;

export const filterFormDefaultValues: FilterFormValues = {
  ...nsnFilterDefaultValue,
  ...responseIdFilterDefaultValue,
  ...markIdFilterDefaultValue,
  ...markerFilterDefaultValue,
  ...reviewerFilterDefaultValue
};
